/** Debounce for collection search input and filter/search analytics. */
export const COLLECTION_SEARCH_DEBOUNCE_MS = 500
